import { render, staticRenderFns } from "./ContractFormsave.vue?vue&type=template&id=afa062ea&scoped=true&"
import script from "./ContractFormsave.vue?vue&type=script&lang=js&"
export * from "./ContractFormsave.vue?vue&type=script&lang=js&"
import style0 from "./ContractFormsave.vue?vue&type=style&index=0&id=afa062ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa062ea",
  null
  
)

export default component.exports